<template>
    <NuxtLink :to="'/' + blog.customFields.seoUrl" class="group">
        <ShopwareImg
            v-if="blog.media"
            :src="blog.media.url"
            :alt="blog.translated.name"
            class="blog-overview-image h-full w-full max-w-full object-cover"
            id="blog-overview-image"
            :width="400"
            sizes="100vw sm:50vw md:400px" />

        <div class="absolute bottom-[24px] left-1/2 w-full -translate-x-1/2 text-white lg:bottom-[80px]">
            <p
                v-if="blog.translated.name"
                class="px-2 font-monument-extended text-sm duration-300 group-hover:text-green-600 lg:text-lg">
                {{ blog.translated.name }}
            </p>
            <p
                v-if="blog.translated.shortDescription"
                class="w-full font-mori text-sm font-light duration-300 group-hover:text-green-600">
                {{ formattedDescription(blog.translated.shortDescription) }}
            </p>

            <button
                class="mx-auto hidden border-b-2 text-center font-mori text-sm duration-300 hover:border-green-600 hover:text-green-600 group-hover:border-green-600 group-hover:text-green-600 lg:block">
                {{ snippets['headless.blogs.readMore'] }}
            </button>
        </div>
    </NuxtLink>
</template>

<script setup lang="ts">
    const snippetsStore = useSnippetsStore();
    const snippets = snippetsStore.snippets;

    const props = defineProps({
        blog: {
            type: Object,
            required: true,
        },
    });

    const formattedDescription = (description: string) => {
        if (!description) return '';
        if (isMobile.value) {
            const parts = description.split('-');
            return parts.length > 1 ? parts[1].trim() : description;
        }
        return description;
    };

    const formatedSeoUrl = (url: string) => {
        if (!url) return '';
        const segments = url.split('/');
        return `/blog/${segments[segments.length - 1]}`;
    };

    const isMobile = computed(() => {
        if (typeof window !== 'undefined') {
            return window.innerWidth <= 768;
        }
        return false;
    });
</script>
